const assets = {
    images: {
        logoinitial: require("./images/logoinitial.png"),
        profile: require("./images/profileicon.png"),
        emailicon: require("../assets/images/EmailIcon.png"),
        greenCross: require("../assets/images/GreenCross.svg").default,
        blueCross: require("../assets/images/BlueCross.svg").default,
        novarumLogo: require("../assets/images/novarumLogo.png"),
        premierbiotechlogo: require("../assets/images/Premier_Biotech_Logo.png"),
        premierbiotechlogolong: require("../assets/images/Premier_Biotech_Logo_expand.png"),
        pbiologoexpand: require("../assets/images/pbiologoexpand.png"),
        pbiologosmall: require("../assets/images/pbiologosmall.png"),
        ct_scan_large: require("./images/ct_scan_large.png"),
        normalresult: require("./images/normal_result.png"),
        moderateresult: require("./images/moderate_result.png"),
        highresult: require("./images/high_result.png"),
        invalidresult: require("./images/invalid_result.png"),
        apple: require("./images/silver_apple_logo.png"),
        android: require("./images/android_logo.png"),
        reprocessed: require("./images/reprocessed_logo.png"),
        ISOManufactureDate: require("./images/ISOManufactureDate.png"),
        ISOManufacturedBy: require("./images/ISOManufacturedBy.png"),
        good: require("./images/good.png"),
        ok: require("./images/ok.png"),
        bad: require("./images/bad.png"),
        world_map: require("./images/world_map.png"),
        udi: require("./images/udisymbol.png")
    },
    actions: {},
    fonts: {}
}

export default assets;